import React from 'react'
import './Contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { FaTelegram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

const Contact = () => {
  return (
    <section id='contact'>
      <div className="section__wrapper contact__container">
        <div className="section__header">
          <h2 className='primary__title'>Contact Me</h2>
          <div className="text__muted description">
            Ready to take your digital presence to the next level? Whether you're looking to launch a new website, revamp an existing one, or need expert advice on the best web technologies, I'm here to help. Reach out to discuss your project, ask questions, or just say hello.
          </div>
        </div>

       <div className="contact__group">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__icon'/>
            <h3>Email</h3>
            <h5>mohitkh22@gmail.com</h5>
            <a href="mailto:mohitkh22@gmail.com"  className='btn'>Send a message</a>
          </article>

          <article className="contact__option">
            <FaLinkedin className='contact__icon'/>
            <h3>Linkedin</h3>
            <h5>Mohit Kholiya</h5>
            <a href="https://www.linkedin.com/in/mohit-kholiya/" className='btn'>Send a message</a>
          </article>

          <article className="contact__option">
            <FaTelegram className='contact__icon'/>
            <h3>Telegram</h3>
            <h5>@Mohit_100</h5>
            <a href="https://t.me/Mohit_100" className='btn'>Send a message</a>
          </article>


        </div>
        {/* END OF CONTACT OPTION */}

        <form action="https://api.web3forms.com/submit" method="POST" /* ref={form} onSubmit={sendEmail} */>
        <input type="hidden" name="access_key" value="001822c1-ba45-4a03-99dd-b7069b25cd82"/>

          <input type="text" name='name' placeholder='Your Full name' required/>
          <input type="email" name='email' placeholder='Your Email' required/>
          <textarea name="message"  rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn__primary'>Send Message</button>
        </form>
       </div>
      </div>
    </section>
  )
}

export default Contact
